import ComparisonPage, { CollegeCompareProvider } from '@scoir/college-compare'
import '@scoir/college-compare/dist/college-compare.css'

import _withCollegeCompare from './with-college-compare'

export const withCollegeCompare = _withCollegeCompare

export const StudentCollegeCompareProvider = _withCollegeCompare(CollegeCompareProvider)
export const StudentCollegeComparePage = _withCollegeCompare(ComparisonPage)
